// GET_RETRIEVE_WEATHER_BY_LOCATION
export const GET_RETRIEVE_WEATHER_BY_LOCATION = 'GET_RETRIEVE_WEATHER_BY_LOCATION';
export const GET_RETRIEVE_WEATHER_BY_LOCATION_SUCCESS = 'GET_RETRIEVE_WEATHER_BY_LOCATION_SUCCESS';
export const GET_RETRIEVE_WEATHER_BY_LOCATION_FAILED = 'GET_RETRIEVE_WEATHER_BY_LOCATION_FAILED';
export const CLEAR_GET_RETRIEVE_WEATHER_BY_LOCATION = 'CLEAR_GET_RETRIEVE_WEATHER_BY_LOCATION';
